import { render, staticRenderFns } from "./deletePropertyRightRegistration.vue?vue&type=template&id=391e5093&scoped=true"
import script from "./deletePropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./deletePropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./deletePropertyRightRegistration.vue?vue&type=style&index=0&id=391e5093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e5093",
  null
  
)

export default component.exports